import { Flipped, Flipper } from 'react-flip-toolkit';
import { useTranslation } from 'react-i18next';

import Group from './Group';

import { useAppSelector } from '../../store/hooks';

import classes from './GroupList.module.css';

const GroupList = () => {
  const consumptions = useAppSelector(state => state.consumptions.consumptions);
  const { t } = useTranslation();

  if (consumptions.length === 0) {
    return <p>{t('group.empty')}</p>;
  }

  const sortedConsumptions = [...consumptions].sort((a, b) => (a.score > b.score ? -1 : 1));
  const maxScore = sortedConsumptions[0]?.score ?? 0;

  const flipKey = sortedConsumptions.map(c => c.score).join(',');

  return (
    <div className={classes.flipperContainer}>
      <Flipper element="ul" flipKey={flipKey} className={classes.flipper}>
        {sortedConsumptions.map((competitor, index) => (
          <Flipped key={competitor.id} flipId={competitor.id}>
            <li>
              <Group
                place={index + 1}
                id={competitor.id}
                name={competitor.name}
                score={competitor.score}
                maxScore={maxScore}
              />
            </li>
          </Flipped>
        ))}
      </Flipper>
    </div>
  );
};

export default GroupList;
